export const beforeItems: string[] = [
  'Serate passate a cercare sequenze sparse fra video e gruppi',
  'Lezioni improvvisate che cambiano forma ogni settimana',
  'Nessuna progressione chiara fra principianti e avanzati',
  'Schede scritte a mano, diverse per ogni allieva',
  'Difficoltà a spiegare i benefici di ogni esercizio',
]

export const afterItems: string[] = [
  'Sequenze complete già pronte, lezione per lezione',
  'Un repertorio ordinato e sempre uguale a se stesso',
  'Progressioni definite su tre livelli: base, intermedio, avanzato',
  'Schede illustrate identiche da consegnare a ogni allieva',
  'Descrizione, benefici e ripetizioni scritti per ogni esercizio',
]

export const transformationStats: [string, string][] = [
  ['480', "PAGINE PRONTE ALL'USO"],
  ['8 SEQUENZE', 'IN OGNI SINGOLO VOLUME'],
  ['3 LIVELLI', 'PER OGNI ESERCIZIO'],
]
